export default __webpack_public_path__ + "static/media/xnft icon_2 1.efa1372e.svg";